import axios from "axios";

export const permissionMixin = {
    data() {
        return {
            companyId: null,
        }
    },
    created() {
        if (this.companyId) {
            this.loadCompany(this.companyId).then(value => {})
        }
    },
    methods: {
        can(permission) {
            // check for undefined to ensure we don't bomb if we haven't loaded permissions yet
            if(this.$root.permissions === undefined || this.$root.permissions[this.$root.companyId] === undefined){
                return false;
            }
            return this.$root.permissions[this.$root.companyId].indexOf(permission) !== -1
        },
        getPermissions() {
            return this.$root.permissions[this.$root.companyId]
        },
        canAsync(permission, companyId) {
            if (!companyId) {
                companyId = this.$root.companyId
            }
            return new Promise((resolve, reject) => {
                this.loadCompany(companyId).then(
                    permissions => {
                        resolve(permissions.indexOf(permission) !== -1)
                    }
                )
            })
        },
        loadCompany(companyId = null) {
            if(companyId === null){
                let path = window.location.pathname.split('/');
                let tmpCompanyId = path[1];
                if(tmpCompanyId){
                    companyId = tmpCompanyId;
                }
                if (companyId === 'sites' || companyId === 'enterprise-dashboard') {
                    companyId = 'sonicu'
                }
            }
            if (companyId || !this.$root.companyId) {
                this.$root.companyId = companyId
            }
            return new Promise((resolve, reject) => {
                if (this.$root.permissions[companyId]) {
                    resolve([])
                } else {
                    $.getJSON('/api-internal/' + companyId + '/permissions/',
                        (data) => {
                            this.$root.permissions[companyId] = data
                            resolve(this.$root.permissions[companyId])
                        }
                    )
                }
            })
        },
        featureFlagValuePromise(featureFlagName, companyId = null){
            if(companyId === null){
                companyId = this.$root.companyId;
            }

            return axios.get('/api-internal/' + companyId + '/options/' + featureFlagName, {validateStatus: false})
                .then(response => {
                    if(response.status !== 200){
                        return null;
                    }
                    if(response.data.data.hasOwnProperty('value')){
                        return response.data.data['value'];
                    }
                });
        }
    },
    computed: {
        urlCompanyId() {
            let id = window.location.pathname
            id = id.split('/')[1]

            let blacklist = ['SonicuTools', 'scripts',]
            if (blacklist.indexOf(id) !== -1) {
                return 'sonicu'
            }
            else {
                return id
            }
        },
        isSonicu() {
            return this.can('do_anything')
        },
        isSonicuViewOnly() {
            return this.can('see_anything')
        },
        isPartner() {
            return this.can('is_partner')
        },

        // Environment Properties
        isLocalEnvironment() {
            let host = window.location.host
            return host === 'localhost' || host === '127.0.0.1'
        },
        isStagingEnvironment() {
            let host = window.location.host
            return host === 'sonistaging.com' || host === 'www.sonistaging.com'
        },
        isQaEnvironment() {
            let host = window.location.host
            return host === 'qa.sonicumonitoring.com'
        },
        isProductionEnvironment() {
            let host = window.location.host
            return host === 'www.sonicumonitoring.com' || host === 'sonicumonitoring.com'
        },
    },
}
